"use client";

import cn from "clsx";
import { Plus } from "lucide-react";
import { motion } from "framer-motion";

import { Button } from "ui";

interface CreateActionButtonProps {
  label: string;
  shortcutKey: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}

export default function CreateActionButton({
  label,
  shortcutKey,
  onClick,
  className,
  disabled = false,
}: CreateActionButtonProps) {
  return (
    <motion.div whileHover="hover" className={cn("inline-flex", className)}>
      <Button
        onClick={onClick}
        disabled={disabled}
        variant="outline"
        className="min-w-32 p-4"
      >
        <motion.span
          className="mr-1.5 inline-flex"
          variants={{ hover: { rotate: 90 } }}
          transition={{ type: "spring", stiffness: 300, damping: 15 }}
        >
          <Plus className="h-4 w-4" />
        </motion.span>
        {label}
        <kbd className="ml-1.5 rounded border border-current px-1 font-mono text-[10px] leading-4 opacity-50">
          {shortcutKey.toUpperCase()}
        </kbd>
      </Button>
    </motion.div>
  );
}
